export const getStyles = () => ({
  footerContainer: {
    backgroundColor: "#FFC02C",
    marginInline: "-16px",
  },
  footerSection: {
    display: "grid",
    textAlign: "center",
    "& > *": {
      paddingBlock: "32px",
    },

    "@media (min-width: 960px)": {
      gridColumn: "2 / -2",
      gridTemplateColumns: "repeat(3, 1fr)",

      "& > *": {
        paddingBlock: "64px",
      },
    },
  },
  footerDownload: {
    display: "none",

    "& h4": {
      fontSize: "1.5rem",
      fontWeight: 600,
    },

    "@media (min-width: 960px)": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 4,
    },
  },
  footerSocials: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#994498",
    alignSelf: "stretch",
    color: "#fff",
    paddingInline: "80px",
    marginInline: "-16px",
    "& h4": {
      fontSize: "0.875rem",
      fontWeight: 600,
    },

    "@media (min-width: 960px)": {
      marginInline: 0,

      "& h4": {
        fontSize: "1.5rem",
      },
    },
  },
  footerLinks: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,

    "& .MuiButtonBase-root": {
      border: "none",
      "@media (min-width: 960px)": {
        fontSize: "1.25rem",
      },
    },
  },
  socialsImages: {
    display: "flex",
    gap: 4,
    marginTop: "24px",

    "& img": {
      width: "32px",
      height: "32px",
    },

    "& button": {
      padding: 0,
    },

    "@media (min-width: 960px)": {
      gap: 2,
      "& .MuiIconButton-root": {
        "& *": {
          borderRadius: "16px",
        },
      },

      "& img": {
        width: "72px",
        height: "72px",
      },
    },
  },
});
